import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { WEB_SOCKET_MODULE } from '../../configs/moduleNames';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';

export const WS_CONNECTION = '_WS_CONNECTION';
export const WS_DISCONNECTION = '_WS_DISCONNECTION';
export const ON_MESSAGE = '_ON_MESSAGE';
export const SET_GPS_DATA = '_SET_GPS_DATA';
export const TOGGLE_SAVE_GPS_SOURCE = '_TOGGLE_SAVE_GPS_SOURCE';
export const CLEAR_GPS_SOURCE = '_CLEAR_GPS_SOURCE';

export const wsConnection = createDeferredAction(WEB_SOCKET_MODULE + WS_CONNECTION);
export const wsDisconnection = createDeferredAction(WEB_SOCKET_MODULE + WS_DISCONNECTION);
export const wsConnectionSuccessful = createAction(WEB_SOCKET_MODULE + WS_CONNECTION + SUCCESSFUL);
export const wsConnectionFailed = createAction(WEB_SOCKET_MODULE + WS_CONNECTION + FAILED);
export const wsConnectionOnMessage = createAction(WEB_SOCKET_MODULE + WS_CONNECTION + ON_MESSAGE);
export const setGPSData = createAction(WEB_SOCKET_MODULE + SET_GPS_DATA);
export const toggleSaveGPSSource = createAction(WEB_SOCKET_MODULE + TOGGLE_SAVE_GPS_SOURCE);
export const clearGPSSource = createAction(WEB_SOCKET_MODULE + CLEAR_GPS_SOURCE);
